module.exports = __webpack_public_path__ + "img/bg_intro_3_3.5ad64f5b.svg";